import { useMutation } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { useActiveOrganization } from "@/hooks/organizations";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast } from "@/utils/toast";

export interface ChangePlanRequest {
  new_plan: string;
}

export interface ChangePlanResponse {
  success: boolean;
  message: string;
  subscription_id: string;
  new_plan: string;
  status: string;
}

export const useChangePlan = () => {
  const userToken = useAuth()?.userToken ?? "";
  const activeOrganization = useActiveOrganization();

  return useMutation({
    mutationFn: async ({ new_plan }: ChangePlanRequest): Promise<ChangePlanResponse> =>
      fetch(ENDPOINTS.billing.change_plan, {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify({
          organization_id: activeOrganization.data?.id,
          new_plan,
        }),
      }).then(handleResponse),
    onError: error => {
      displayErrorToast(error as string);
    },
  });
};
